<div *ngIf="!fullCard">
  <div class="" *ngIf="loading">
    <edp-loader [size]="'md'" class="text-center my-auto" ></edp-loader>
  </div>
  <div class="" (resized)="chartConstruction()" [class.d-none]="loading">
    <span class="chart-title">{{ 'pt.edp.edponline.chart.legend' | translate }}</span>
    <div id="{{ chartName }}" class="card-chart"></div>
    <div class="card-chart-overlay" *ngIf="noInvoices">
        <span class="card-text">{{ 'pt.edp.edponline.chart.no.data' | translate }}</span>
    </div>
  </div>
</div>

<div *ngIf="fullCard" style="height: 100%;">
  
  <div class="header">
    <ng-container *ngIf="!showBalance">
      <span class="title">{{ 'pt.edp.edponline.chart.legend' | translate }}</span>
    </ng-container>
    <ng-container *ngIf="showBalance">
      <span class="title">{{ value }},{{ decimals }}{{ 'pt.edp.edponline.chart.in.credit' | translate }}</span>
    </ng-container>
  </div>
  <div class="card-body" *ngIf="loading">
    <edp-loader [size]="'md'" class="text-center my-auto" ></edp-loader>
  </div>
  <div class="card-body" (resized)="chartConstruction()" [class.d-none]="loading">
    <div id="{{ chartName }}" class="card-chart"></div>
    
  </div>
  <div class="card-chart-overlay-billing" *ngIf="noInvoices">
    <span class="card-text">{{ 'pt.edp.edponline.chart.no.data' | translate }}</span>
  </div>
</div>
